module.exports = __webpack_public_path__ + "static/desktop/img/step-album.fae7b338.png";